<template>
    <div class="all">
        <div class="warp">
            <div class="warp-body">
                <div class="firle clearfix">
                    <h2 class="">我的收藏</h2>
                    <div class="mt20">
                        <label class="checkbox-box tion">
                            <label class="checkbox-warp fl" :class="ids.length === pageUuid.length && ids.length > 0 ? 'curr' : ''">
                                <input class="checkbox" name="selectAll" @click="checkAll($event)" :checked="ids.length === pageUuid.length && ids.length > 0 ? true : false" type="checkbox" value="">
                                <i class="icons checkbox-icon"></i>
                            </label>
                            全选
                        </label>
                        <span class="checkbox-box cp tion" @click="cancelCollect();">批量取消收藏</span>
                    </div>
                </div>
                <div class="no-data" v-if="nodata"><span class="text">没有数据哦...</span></div>
                <ul class="article-list">
                    <li v-for="(item,index) in list" :key="index">
                        <div class="article-left fl">
                            <label class="checkbox-warp" :class="ids.indexOf(item.typeId) != -1 ? 'curr' : ''">
                                <input class="checkbox" v-model="ids" type="checkbox" name="chooseInfo" :value="item.typeId">
                                <i class="icons checkbox-icon"></i>
                            </label>     
                        </div> 
                        <div class="article-right fr">
                            <div class="article-btn">
                                <a class="color-orange" href="javascript:void(0);" @click="cancelCollect(item.typeId);">取消收藏</a>
                            </div>  
                        </div> 
                        <div class="article-mid">
                            <a class="color-3d3d4c" href="javascript:void(0);" @click="newsJump(item.typeId,item.newsSimHash,item.isEffective);">
                                <h2 class="article-title ovhidden2">{{item.title}}</h2>
                                <p class="mt5 color-8a8a99 ovhidden2">{{item.summary}}</p>
                                <p class="ziduan color-8a8a99 mt10">
                                    <span>发布时间：{{item.publishTime}}</span>
                                    <span>发布人：<i class="icons sm-icon" :class="icons[item.sourceType]"></i>{{item.source}}</span>
                                </p>
                            </a>
                        </div> 
                    </li>
                </ul>
                <!-- 分页 -->
                <page class="mt20" v-if="totalCount != ''" :currentPage.sync="page" :limit.sync="limit" :totalCount="totalCount"  @turn="getTableData"></page>
            </div>
        </div>
	</div>
</template>
<script>
import page from '../../components/page.vue';
export default {
    components: {page},
    data() {
        return {
            pageUuid:[],//单分页所有的uuid
            icons:{
                'wx':'wx-icon',
                'web':'web-icon1',
                'weibo':'wb-icon1',
                'app':'app-icon1',
                'bbs':'bbs-icon1',
                'journal':'bk-icon1',
                'media_toutiao':'tt-icon1',
                'media_qq':'qq-icon1',
                'media_baijia':'bj-icon1',
                'media_sohu':'sh-icon1',
                'media_wangyi':'wy-icon1',
                'media_people':'people-icon1'
            },
            ids:[],//选择的uuid数组
            page:1,
            nodata:'',
		    limit:20,//每页显示条数
            totalCount:'',//总页数
            list:[]//列表
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            that.getCollectList();
        }) 
    },
    created() {
		
    },
    methods: {
		// 获取收藏列表
        getCollectList (type) {
            let that = this;
            that.ids = [];
            if(type === 0){
               that.page = 1; 
            }
            $(".warp .checkbox-warp").removeClass('curr');
            $(".warp input:checkbox[name='selectAll']").prop("checked",false);
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('user/index/collection-records',{page:that.page,perpage:that.limit},r =>{
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    that.list = r.data.list;
                    if(r.data.list.length <= 0){//没有数据
                        that.nodata = true;
                        return;
                    }else{
                        that.nodata = false;
                    } 
                    that.totalCount = r.data.total;
                    let pageUuid = [];
                    for(let i of r.data.list){
                        pageUuid.push(i.typeId);
                    }
                    that.pageUuid = pageUuid;
                })
            })
        },
        //新闻详情跳转
        newsJump (id,newsSimHash,type) {
            if(type === 2){//过期无法跳转
                this.$utils.alertText('收藏文章已失效');
            }else{
                let startDate = this.$utils.getNowDate();//今天时间
                let endDate = this.$utils.getBeforeDay(this.startDate,7,1);//前一天
                let data = id + ',' + newsSimHash + ',' + startDate + ',' + endDate;
                let routeData = this.$router.resolve({path:'/detail',query:{data:data}})
				window.open(routeData.href, '_blank');
            }
        },
        // 全选状态
        checkAll (e) {
            let that = this;
            let checked = e.target.checked;
            that.ids = [];
            if(checked == true){
                that.ids = that.pageUuid;//全选的时候 获取所有的uuid
            }else{
                that.ids = [];
            }
        },
        // 翻页
        getTableData () {
            let that = this;
            that.getCollectList();
        },
        // 取消收藏
        cancelCollect (id) {
            let that = this;
            let ids = '';
            if(id === undefined){//批量预警
                ids = that.ids;
                if(ids.length <= 0){
                    that.$utils.alertText('您未选择任何新闻');
                    return;
                }
            }else{
                ids = [id];
            }
            let datas = {
                type:1,
                typeId:ids
            }
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.post('user/index/cancel-collect',{data:datas},r =>{
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.getCollectList(0);
                })
            })
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/personalCenter/myCollect.vue